

export const DRAFT_KEY = "story_editor_draft_v1";

export const SYNC_KEY = "chat_sync_timestamp";